var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.086,
    height: 44.342,
    viewBox: "0 0 44.086 44.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.043,
    cy: 22.171,
    rx: 22.043,
    ry: 22.171,
    transform: "translate(0 0)",
    fill: "#394F65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-340.841,1911.365c1.084,1.359,2.147,2.663,3.177,3.993a35.826,35.826,0,0,1,3.556,5.494,12.771,12.771,0,0,1,1.3,3.516,7.378,7.378,0,0,1-.045,2.525,9.258,9.258,0,0,1-3.342,6.025,7.039,7.039,0,0,1-7.382,1.165,8.3,8.3,0,0,1-4.5-4.464,10.537,10.537,0,0,1-.93-3.907,7.45,7.45,0,0,1,.573-3.1,25.935,25.935,0,0,1,3.072-5.514,62.407,62.407,0,0,1,4.362-5.545Zm6.411,14.028c0-.1,0-.2,0-.307a1.157,1.157,0,0,0-1.185-1.208,1.161,1.161,0,0,0-1.182,1.186c-.014.25-.023.5-.061.75a4.831,4.831,0,0,1-1.615,3.208c-.186.153-.4.274-.583.43a1.233,1.233,0,0,0-.251,1.589,1.2,1.2,0,0,0,1.6.386,5.937,5.937,0,0,0,2.024-1.922A8.253,8.253,0,0,0-334.431,1925.394Z",
    transform: "translate(362.974 -1900.701)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjDiabetes);
export default __webpack_public_path__ + "static/media/OBJ-DIABETES.b2b717e87d2bd569c8e7c2b70032642c.svg";
export { ForwardRef as ReactComponent };